"use_strict"

class NewsletterForm {
	constructor () {
		this._newsletterForm  = document.querySelector('.section--newsletter .section__form');
		this._newsletterField = document.querySelector('.input--newsletter');

		if ( !this._newsletterForm || !this._newsletterField ) return;

		this._bindUIActions();
	}

	/**
	 * @function _bindUIActions
	 * @desc Add event listener to the newsletter form's field
	 */
	_bindUIActions () {
		let newsletterForm = this._newsletterForm;
		let newsletterField = this._newsletterField;

		newsletterField.addEventListener( 'focusin', function () {
			newsletterForm.classList.add( 'focused' );
		});

		newsletterField.addEventListener( 'focusout', function () {
			if ( this.value == '') {
				newsletterForm.classList.remove( 'focused' );
			}
		});
	}
}

export { NewsletterForm }
